<template>
	<b-card style="margin: 0">
		<b-card-header>
			<b-row class="mb-3">
				<b-col cols="2">
					<b-button @click="$router.back()" variant="outline-dark"><i class="fa fa-chevron-left"></i> {{
						$t('back') }}</b-button>
				</b-col>
				<b-col>
					<date-picker v-model="fromDate" lang="ru" style="width: 100%"
						:placeholder="$t('certificate.fromDate')" valueType="format" format="DD-MM-YYYY" />
				</b-col>
				<b-col>
					<date-picker v-model="toDate" lang="ru" style="width: 100%" :placeholder="$t('certificate.toDate')"
						value-type="format" format="DD-MM-YYYY" />
				</b-col>
				<b-col align="right" cols="2">
					<b-button @click="getItems" variant="dark" class="fa fa-search mr-2" />
				</b-col>
			</b-row>
		</b-card-header>
		<b-card-body class="marginPage">
			<b-overlay :show="loading" rounded="sm">
				<b-row>
					<b-col cols="3">
						<div style="font-size: 10px">DutyFree International</div>
					</b-col>
					<b-col cols="6" class="text-center">
						<h6><b>{{ $t("report KPI") }} {{ $t("c") }} {{ fromDate ? fromDate : '________' }} {{ $t("po") }} {{
							toDate ? toDate : '________' }}</b></h6>
					</b-col>
				</b-row>
				<b-row class="mt-4">
					<b-col>
						<template v-for="item in items">
							<b-table :items="item.sales" :fields="computedFields" id="gridContainer" :busy="loading"
								:responsive="true" small bordered show-empty striped hover foot-clone no-footer-sorting
								label-sort-asc="" label-sort-desc="" label-sort-clear="">
								<template #table-busy>
									<div class="text-center my-2">
										<b-spinner small class="mr-2" /><strong>Loading...</strong>
									</div>
								</template>
								<template #cell(index)="data">
									{{ data.index + 1 }}
								</template>
								<template #cell(full_name)="data">
									{{ data.item.fullName }}
								</template>
								<template #cell(department)="data">
									{{ item.departmentName }}
								</template>
								<template #cell(Total_revenue)="data">
									{{ data.item.totalSale }}
								</template>
								<template #cell(Total_revenue1)="data">
									{{ data.item.value | currency({
										symbol: '', fractionCount: 2, symbolPosition: 'back',
										thousandsSeparator: ' '}) }}
								</template>
								<template #cell(finalKpi)="data">
									{{ data.item.finalKpi }}
								</template>
								<template #foot(index)="data"><span></span></template>
								<template #foot(full_name)="data"><span></span></template>
								<template #foot(department)="data">
									<b>{{ $t("Itogo") }}</b>
								</template>
								<template #foot(Total_revenue)="data">
									<!--									<b>{{ sumSaleInEur | currency({symbol: '', fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '}) }}</b>-->
									<b>{{ item.totalSales }}</b>
								</template>
								<template #foot(Total_revenue1)="data">
									<!--									<b>{{sumSaleInUzs | currency({symbol: '', fractionCount: 2, symbolPosition: 'back', thousandsSeparator: ' '}) }}</b>-->
									<b>{{ item.totalKpi }}</b>
								</template>
								<template #foot(finalKpi)="data"><span></span></template>
							</b-table>
						</template>
					</b-col>
				</b-row>
			</b-overlay>
		</b-card-body>
	</b-card>
</template>

<script>
import Multiselect from "vue-multiselect";
import { BTable } from "bootstrap-vue";
import { BOverlay } from 'bootstrapVue2';
import ReportService from "../../analytics/otchot/report.service";

export default {
	name: "kpi",
	components: { Multiselect, BOverlay, BTable },
	data() {
		return {
			items: [],
			fields: [
				{ key: 'index', label: '№', class: 'text-center', visible: true },
				{ key: 'full_name', label: this.$t("Employee_(full_name)"), class: 'text-center', visible: true, sortable: true },
				{ key: 'department', label: this.$t('pricing.department'), class: 'text-center', visible: true, sortable: true },
				{ key: 'Total_revenue', label: this.$t("Total_revenue"), class: 'text-center', visible: true, sortable: true },
				{ key: 'Total_revenue1', label: this.$t("Total_revenue1"), class: 'text-center', visible: true, sortable: true },
				{ key: 'finalKpi', label: 'В процентах', class: 'text-center', visible: true, sortable: true },
			],
			fromDate: null,
			toDate: null,
			loading: false
		}
	},
	computed: {
		computedFields() {
			let tmp = []
			this.fields.forEach(t => {
				if (t.visible)
					tmp.push(t)
			})
			return tmp
		},

		// sumSaleInEur() {
		// 	let sum = 0
		// 	this.items.forEach(t => {
		// 		if (t.totalSale)
		// 			sum = sum + parseFloat(t.totalSale.toFixed(2))
		// 	})
		// 	return sum;
		// },
		// sumSaleInUzs() {
		// 	let sum = 0
		// 	this.items.forEach(t => {
		// 		if (t.value)
		// 			sum = sum + parseFloat(t.value.toFixed(2))
		// 	})
		// 	return sum;
		// }
	},
	methods: {
		getItems() {
			this.loading = true
			this.items = []
			if (this.fromDate && this.toDate) {
				let data = {
					startDate: this.fromDate,
					endDate: this.toDate,
					deps: [this.$route.params.depId],
					employees: [],
					persistent: 0.6
				}
				ReportService.getReportKpi(data).then(res => {
					this.items = res.data
					this.loading = false
				}).catch(e => {
					this.loading = false
					this.$vs.notify({
						title: e.message,
						color: 'danger',
						icon: 'close',
						position: 'top-right'
					});
				})
			} else {
				this.loading = false
				this.$vs.notify({
					text: `Заполните ${this.$t('certificate.fromDate')} и ${this.$t('certificate.toDate')}`,
					color: "warning",
					icon: "close",
					position: "top-right"
				});
				return 0;
			}
		}
	}
}
</script>

<style scoped></style>
